export const getRoundedPercentage = (baseNumber: number, total: number): string => {
    if (total === 0) return "0";
    const percentage = Math.round((baseNumber / total) * 100);
    return percentage.toString();
};
